export default "__VITE_ASSET__DH7hwko0__"